import { Injectable } from "@angular/core";
import { Http, URLSearchParams, Headers } from "@angular/http";
import { BaseService } from "../base.service";
import { CookieService } from "ngx-cookie-service";
import { environment } from "../../environments/environment";

@Injectable()
export class ExportProductsService extends BaseService {
  constructor(http: Http, cookieService: CookieService) {
    super(http, cookieService);
    this.init("export-list");
  }

  getProducts(magicLink, filters = {}) {
    let headers = new Headers();
    headers.append("Accept", "application/json");
    // headers.append("Authorization", magicLink);
    filters["magic_link"] = magicLink;
    if (filters["required_token"]) {
      filters["required_token"] = true;
    }
    var params = new URLSearchParams();

    for (var filter of Object.keys(filters)) {
      params.append(filter, filters[filter]);
    }

    return this.http
      .get(this.baseURL(), { search: params, headers: headers })
      .toPromise()
      .then(response => {
        let res = response.json();
        if (res["token"]) {
          this.setCookie("token", res["token"]);
        }
        return res;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/products/export_products.service.ts